<template>
  <div>
    <card title="Familia de Materiales" icon="fas fa-th-list ">
        <div class="table-responsive">
          <div class="card mb-4">
            <div class="card-body">
              <div class="row">
                <div class="form-group col-md-4">
                  <label for>Categoría</label>
                  <v-select :options="categories" v-model="category" :filterable="false" >
                    <span slot="no-options">No se encontraron registros</span>
                  </v-select>
                </div>
                <div class="form-group col-md-6">
                  <label for>Familias sin Asociar</label>
                  <v-select :options="ListMaterialsNoAsociate"  v-model="family" :filterable="false" >
                    <span slot="no-options">No se encontraron registros</span>
                  </v-select>
                </div>
                <div class="form-group col-md-2">
                  <button @click="store" class="btn btn-success mt-4"><i class="fa fa-tasks"></i> Asignar</button>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body" style="text-align: center;">
                <div style="display: inline-table; width: 30%; padding: 20px;" class="card mb-4 mr-4"  v-for="item in ListCategories" :key="item.id">
                  <table class="table table-striped table-bordered" style="text-align: left;">
                    <tr>
                      <th style="width: 30%;" class="bg-secondary">Tipo de Insumo</th>
                      <td ><span style="font-size: 16px;"><b>{{item.category}}</b></span></td>
                    </tr>
                    <tr>
                      <th class="bg-secondary" style="text-align: left;">Familias Asignadas</th>
                      <td>
                        <table class="table">
                          <tr v-for="mf in item.materialFamilies" :key="mf.id">
                            <td>
                              {{mf.materialName}}
                            </td>
                            <td>
                              <button @click="removeCategoryFamily(item.category, mf.materialName, mf.id)" class="btn btn-sm btn-danger"><i class="fas fa-trash"></i></button>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </div>
            </div>
          </div>
        </div>
    </card>

    <!-- Familias de material que no se consideran en las fórmulas de Producto Terminado -->
    <card title="Familias de Materiales que no se consideran en las Fórmulas" icon="fas fa-ban">
      <div class="card mb-4">
        <div class="card-body">
          <div class="row">
            <div class="form-group col-md-9">
              <label for>Familia de Material (d_material)</label>
              <v-select :options="availableMaterials" v-model="selectedMaterial">
                <span slot="no-options">No se encontraron familias de material</span>
              </v-select>
              <small class="text-muted d-block mt-1">Puede buscar por el nombre de la familia de material.</small>
            </div>
            <div class="form-group col-md-3">
              <button @click="addExcluded" class="btn btn-success mt-4" :disabled="!selectedMaterial">
                <i class="fa fa-plus"></i> Agregar
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <table class="table table-striped table-hover table-bordered">
            <thead class="thead-dark">
              <tr>
                <th>Familia de Material</th>
                <th style="width: 120px; text-align: center;">Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="excludedFamilies.length === 0">
                <td colspan="2" class="text-center text-muted">Aún no hay familias excluidas.</td>
              </tr>
              <tr v-for="item in excludedFamilies" :key="item.id">
                <td>{{ item.materialName }}</td>
                <td style="text-align: center;">
                  <button @click="removeExcluded(item.id, item.materialName)" class="btn btn-sm btn-danger">
                    <i class="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import { Get, Delete, Post } from "../../helper/axios.js";
import Card from "../../components/Card.vue";
export default {
  components: {
    Card
  },
  data() {
    return {
      ListCategories: [],
      ListMaterialsNoAsociate: [],
      Post,
      Delete,
      apiUrl: this.$store.getters.apiUrl,
      modalTitle: '',
      Get,
      materialToAssociate: '',
      category: '',
      family: '',
      distinctMaterials: [],
      excludedFamilies: [],
      selectedMaterial: '',

    };
  },
  created() {
    this.index();
    this.getDistinctMaterials();
    this.getExcludedFamilies();
  },
  methods: {
    index() {
      this.ListCategories = [];
      this.ListMaterialsNoAsociate = [];
      this.$store.commit("setLoading", true);   
      this.Get(this.apiUrl + "v1/materialfamilies", res => {
        this.ListCategories = res.data;
        this.$store.commit("setLoading", false);
      });

      this.$store.commit("setLoading", true);
      this.Get(this.apiUrl + "v1/materialmasteritems", res => {
        this.ListMaterialsNoAsociate = res.data;
        this.$store.commit("setLoading", false);
      });
        
    },
    removeCategoryFamily(category, name, id){
      this.$swal({
          title: "¿Desea eliminar la asociación de la Famila " + name + " de la categoría " + category + "?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33"
        }).then(result => {
          if (result.value) {
            this.$store.commit("setLoading", true);
            this.Delete(this.apiUrl +'v1/materialfamilies/'+id, () => {
              this.$store.commit("setLoading", false);
              window.toastr.success('Asociación de Familia de Material Eliminado correctamente.');
              this.index();
            });
          }
        });
    },
    store(){
      if (this.category && this.family && this.category != "" && this.family != "")
      {
        let data = {
          category: this.category,
          materialName: this.family
        }
        this.$store.commit("setLoading", true);
        this.Post(`${this.apiUrl}v1/materialfamilies/`, data, () =>{
            this.$store.commit("setLoading", false);
            window.toastr.success('Familia asignada correctamente.');
            this.category = '';
            this.family = '';
            this.index();
        });
      }
    },
    getDistinctMaterials() {
      this.$store.commit("setLoading", true);
      this.Get(this.apiUrl + "v1/MasterItems/DistinctMaterials", res => {
        this.distinctMaterials = res.data;
        this.$store.commit("setLoading", false);
      });
    },
    getExcludedFamilies() {
      this.$store.commit("setLoading", true);
      this.Get(this.apiUrl + "v1/excludedmaterialfamilies/all", res => {
        this.excludedFamilies = res.data;
        this.$store.commit("setLoading", false);
      });
    },
    addExcluded() {
      if (!this.selectedMaterial) return;
      let data = { materialName: this.selectedMaterial };
      this.$store.commit("setLoading", true);
      this.Post(`${this.apiUrl}v1/excludedmaterialfamilies`, data, () => {
        this.$store.commit("setLoading", false);
        window.toastr.success('Familia de material excluida correctamente.');
        this.selectedMaterial = '';
        this.getExcludedFamilies();
      });
    },
    removeExcluded(id, name) {
      this.$swal({
        title: "¿Desea quitar la exclusión de la familia " + name + "?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33"
      }).then(result => {
        if (result.value) {
          this.$store.commit("setLoading", true);
          this.Delete(this.apiUrl + 'v1/excludedmaterialfamilies/' + id, () => {
            this.$store.commit("setLoading", false);
            window.toastr.success('Exclusión eliminada correctamente.');
            this.getExcludedFamilies();
          });
        }
      });
    }
  },
  computed:{
    urlQuery(){
        return this.getUrlQuery()
    },
    categories(){
      let list = [];
      this.ListCategories.forEach(element => {
        list.push(element.category)
      });
      return list;
    },
    availableMaterials(){
      let excludedNames = this.excludedFamilies.map(x => (x.materialName || '').toLowerCase());
      return this.distinctMaterials.filter(m => !excludedNames.includes((m || '').toLowerCase()));
    }
  }

}

</script>